import { render, staticRenderFns } from "./Finances.vue?vue&type=template&id=831ae472&scoped=true&"
import script from "./Finances.vue?vue&type=script&lang=ts&"
export * from "./Finances.vue?vue&type=script&lang=ts&"
import style0 from "./Finances.vue?vue&type=style&index=0&id=831ae472&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "831ae472",
  null
  
)

export default component.exports